import { useState, ChangeEvent } from 'react';
import AuthFrame from '../AuthFrame';
import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography
} from '@mui/material';
import theme from '../../constants/theme';
import { CancelDeleteUserButton as LoginActioBtn } from '../Button';
import { OTPOption } from '../../content/auth/login';

interface OTPDeliveryOptionProps {
  options: OTPOption[];
  handleContinue: (selectedId: string) => void;
  handleBackToLogin: () => void;
}

const PageTitle = () => (
  <Typography variant="h5">
    Choose where to receive the verification code for your login.
  </Typography>
);

export default function ChooseOTPOption({
  options = [],
  handleContinue,
  handleBackToLogin
}: OTPDeliveryOptionProps) {
  const [selected, setSelected] = useState<string>(options[0]?.id || '');

  const handleContinueBtnClick = () => {
    if (handleContinue) handleContinue(selected);
  };

  const handleOTPOptionChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSelected(e.target.value);
  };

  return (
    <AuthFrame title={<PageTitle />} titleStyles={{ marginY: 2 }}>
      <Grid container>
        <Grid item xs={12}>
          <FormControl component="fieldset" fullWidth>
            <RadioGroup value={selected} onChange={handleOTPOptionChange}>
              {options.map((option) => (
                <FormControlLabel
                  key={option.id}
                  value={option.id}
                  control={<Radio />}
                  sx={{ alignItems: 'flex-start', marginBottom: 1 }}
                  label={
                    <Box display="flex" flexDirection="column">
                      <Typography variant="subtitle1">
                        {option.label}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {option.description}
                      </Typography>
                    </Box>
                  }
                />
              ))}
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Box display="flex" flexDirection="column" gap={2} py={2}>
            <LoginActioBtn
              sx={{ background: theme.gradient.primary, borderRadius: 10 }}
              variant="contained"
              fullWidth
              onClick={handleContinueBtnClick}
            >
              Continue
            </LoginActioBtn>

            <LoginActioBtn
              sx={{ background: theme.gradient.primary, borderRadius: 5 }}
              variant="contained"
              fullWidth
              onClick={handleBackToLogin}
            >
              Back to Login
            </LoginActioBtn>
          </Box>
        </Grid>
      </Grid>
    </AuthFrame>
  );
}
